// extracted by mini-css-extract-plugin
export var accent = "_88-4";
export var add = "_88-j";
export var addIcon = "_88-k";
export var deleteIcon = "_88-i";
export var disabled = "_88-9";
export var ellipsis = "_88-f";
export var error = "_88-3";
export var form = "_88-5";
export var hideFocus = "_88-2";
export var icon = "_88-7";
export var input = "_88-e";
export var listItem = "_88-h";
export var mediumHeight = "_88-b";
export var noBorder = "_88-8";
export var noRadius = "_88-1";
export var shortHeight = "_88-a";
export var tallHeight = "_88-c";
export var textInput = "_88-0";
export var vertical = "_88-g";
export var veryTallHeight = "_88-d";
export var widget = "_88-6";